import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'bs',
    fullName: 'Bosnian',
    nativeName: 'Bosanski',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Nešto neverovatno dolazi",
    landing_subtitle: "ArgVoid je studio za razvoj aplikacija i igara. Ostanite sa nama, uskoro stižu nove stvari!",
    select_language: "Odaberite Jezik",
    search_placeholder: "Traži jezike...",
    terms_title: "Uslovi korištenja usluge",
    policy_title: "Politika privatnosti",
    cookies_title: "Politika kolačića",
    terms_content: `
        <strong>1. Prihvatanje Uslova </strong><br>
        Pristupanjem ArgVoidu, ovi Uslovi korištenja su prihvaćeni. Ako se ovi uslovi ne slažu, usluga se ne bi trebala koristiti.<br><br>

        <strong>2. Upotreba platforme</strong><br>
        ArgVoid i njegove aplikacije daju se "kao što jesu" u informativne i kreativne svrhe. Usluga se mora koristiti samo u zakonite svrhe.<br><br>

        <strong>3. Zabranjeno ponašanje</strong><br>
        Iskorišćavanje ranjivosti stranice, slanje neželjene pošte ili pokušaj neovlaštenog pristupa infrastrukturi je strogo zabranjeno.<br><br>

        <strong>4. Odricanje od odgovornosti</strong><br>
        Platforma i usluge mogu se mijenjati u bilo koje vrijeme bez prethodne najave. Ne daje se garancija u pogledu trajanja ili dostupnosti usluge.
    `,
    policy_content: `
        <strong>1. Zbirka informacija</strong><br>
        Platforma trenutno ne zahtijeva autentifikaciju korisnika ili kreiranje naloga. Nikakve lične identifikacione informacije (kao što su imena ili adrese e-pošte) se aktivno ne prikupljaju od posetilaca.<br><br>

        <strong>2. Podaci o upotrebi</strong><br>
        Osnovna, anonimna analitika se može prikupiti kako bi se razumio promet na web lokaciji i poboljšale aplikacije. Ovi podaci nisu povezani sa individualnim korisničkim identitetima.<br><br>

        <strong>3. Usluge trećih strana</strong><br>
        Provajderi trećih strana mogu se koristiti za usluge hostinga i analitike. Praksa privatnosti ovih odgovarajućih provajdera reguliše anonimne podatke koji se obrađuju na njihovoj infrastrukturi.<br><br>

        <strong>4. Sigurnost podataka</strong><br>
        Primjenjuju se razumne sigurnosne mjere za zaštitu platforme. Međutim, nijedna metoda prijenosa preko Interneta nije potpuno sigurna.<br><br>
    `,
    cookies_content: `
        <strong>1. Šta su kolačići i lokalna pohrana?</strong><br>
        Kolačići i lokalna pohrana pretraživača su male datoteke s podacima pohranjene na uređaju za pamćenje postavki konfiguracije tijekom posjeta.<br><br>

        <strong>2. Svrha upotrebe</strong><br>
        Pretraživač LocalStorage se koristi isključivo za spremanje postavki konfiguracije, kao što je: <br>
        - Preference jezika<br>
        - Konfiguracija korisničkog sučelja (npr. postavke izgleda ili teme)<br>
        - Privremena predmemorija aplikacije<br><br>

        <strong>3. Nema praćenja</strong><br>
        Kolačići i lokalna pohrana se ne koriste u svrhe oglašavanja ili praćenja trećih strana. Svi pohranjeni podaci su isključivo za osnovnu funkcionalnost platforme.<br><br>

        <strong>4. Control</strong><br>
        Podaci pretraživača mogu se obrisati u bilo kom trenutku kroz postavke pretraživača, što će resetovati sve lokalne konfiguracije.
    `,
    cookie_consent_text: "Koristimo osnovne kolačiće kako bismo osigurali da web stranica ispravno funkcionira, kao što je održavanje vaše sesije aktivnom, spremanje vaših jezičnih postavki i druge prilagođene konfiguracije.",
    read_policy: "Pročitajte politiku kolačića",
    support_title: "Kontaktirajte podršku",
    support_subject_label: "Predmet",
    support_message_label: "Poruka",
    support_submit_button: "Pošalji poruku",
    support_hint: "Napomena: Ovo će otvoriti vašu zadanu aplikaciju za e-poštu za slanje poruke.",
    support_success_msg: "Otvaranje vaše aplikacije za e-poštu...",
    support_error_msg: "Slanje poruke nije uspjelo. Molimo pokušajte ponovo kasnije.",
    explorer_title: "Explorer",
    history_title: "Istorija",
    animation_title: "Animacija",
    config_title: "Konfiguracija",
    tool_mouse: "Odaberite (Ctrl+M)",
    tool_brush: "Četka (Ctrl+B)",
    tool_brush_mode: "Prebaci način rada (Solid/Clear)",
    tool_eraser: "Gumica (Ctrl+E)",
    tool_brush_size: "Podesite veličinu četkice",
    tool_bucket: "Ispuna (Ctrl+F)",
    tool_eyedropper: "Kapaljka za oči",
    tool_grid: "Mreža (Ctrl+Shift+B)",
    tool_rotate: "Rotirajte (Ctrl+Shift+R)",
    tool_flip_h: "Okrenite H (Ctrl+Shift+H)",
    tool_flip_v: "Okrenite V (Ctrl+Shift+V)",
    tool_transpose: "Transponiranje (Ctrl+Shift+T)",
    label_width: "Širina",
    label_height: "Visina",
    label_frames: "Broj okvira",
    label_animation: "Stil animacije",
    label_background_color: "Boja pozadine",
    label_interval: "Interval",
    tool_anim_config: "Konfiguracija animacije",
    label_new_width: "Nova širina",
    label_new_height: "Nova visina",
    label_apply: "Prijavite se",
    label_colors: "Boje",
    label_size: "Veličina",
    label_tolerance: "Tolerancija",
    val_horizontal: "Horizontalno",
    val_vertical: "Vertical",
    val_sequence: "Sequence",
    val_bounce: "Bounce",
    val_random: "Slučajno",
    val_solid: "Solid",
    val_clear: "Jasno",
    action_add_sheet: "New Sheet",
    action_import: "Uvoz",
    action_export: "Izvoz",
    action_sort_projects: "Sortiraj",
    sort_date_old: "Prvo najstariji",
    sort_date_new: "Najnovije prvo",
    sort_name_az: "Ime (A-Z)",
    sort_name_za: "Ime (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "Novi projekat",
    modal_save_all_title: "Sačuvaj sve promjene",
    modal_save_all_desc: "Odaberite sredstva za spremanje:",
    modal_save_selected: "Sačuvaj odabrano",
    action_saved: "Sačuvano",
    modal_create_sprite_title: "Kreirajte novi Sprite",
    modal_create_project_title: "Kreirajte novi projekat",
    modal_add_sheet_title: "Dodaj novi list",
    modal_rename_sheet_title: "Preimenuj list",
    modal_rename_sprite_title: "Preimenuj Sprite",
    modal_delete_sprite_title: "Izbriši Sprite",
    modal_delete_project_title: "Izbriši projekat",
    modal_delete_sheet_title: "Izbriši list",
    placeholder_sprite_name: "Ime",
    placeholder_project_name: "Ime",
    placeholder_sheet_name: "Ime",
    placeholder_new_name: "Novo ime",
    action_create: "Kreiraj",
    action_add: "Dodaj",
    action_rename: "Preimenuj",
    action_duplicate: "Duplikat",
    action_delete: "Izbriši",
    action_cancel: "Otkaži",
    confirm_delete_sprite: "Jeste li sigurni da želite izbrisati ovaj sprite?",
    confirm_delete_project: "Jeste li sigurni da želite izbrisati ovaj projekat? Svi sprajtovi će biti uklonjeni.",
    confirm_delete_sheet: "Jeste li sigurni da želite izbrisati ovaj list?",
    err_select_sprite: "Molimo prvo odaberite sprite.",
    err_select_project: "Molimo prvo odaberite projekat.",
    err_name_empty: "Ime ne može biti prazno.",
    err_sprite_exists: "Sprajt sa tim imenom već postoji.",
    err_project_exists: "Projekt s tim imenom već postoji.",
    err_no_content: "Nema sadržaja za spremanje.",
    err_no_changes: "Nema promjena za spremanje.",
    err_delete_last_sheet: "Nije moguće izbrisati posljednji list.",
    err_extract_frames: "Nije moguće izdvojiti nijedan okvir.",
    err_indexeddb: "Lokalno spremanje nije uspjelo. Vaš pretraživač možda ne podržava IndexedDB.",
    msg_upload_success: "Prijenos uspješno: {0}",
    msg_upload_failed: "Prijenos nije uspio: {0}",
    msg_save_success: "Snimanje uspješno.",
    msg_saving: "Spremanje...",
    msg_multi_save_result: "Sačuvano {0} sredstava. {1} grešaka.",
    menu_title: "Meni",
    menu_save: "Sačuvaj",
    menu_save_all: "Save All",
    menu_support: "Kontaktirajte podršku",
    label_local_storage: "Lokalna pohrana",
    label_sign_in: "Prijavite se",
    modal_export_title: "Izvezi Sprite",
    label_filename: "Ime datoteke",
    label_format: "Format",
    action_export_confirm: "Izvoz",
};

export default translations;
